export enum DataViewerEnum {
  BOTNET_REPORTS = 'botnet-reports',
  INFECTIONS = 'infections',
}
